<template>
  <div>
    <div class="physio-warp" v-for="(item, index) in physioItem" :key="index">
      <div class="physio-top" :class="{ 'disabled': isDisabled }">
        <div class="top-left">
          <img :src="imgArr.phyIcon" class="physio-icon">
          <div class="physio-title">理疗处方 {{ index + 1 }}</div>
          <div>总价￥{{ $toFixed(item.totalPrice) }}</div>
          <el-tooltip v-if="item.items.length > 5" class="item" effect="light" content="单张理疗处方项目数超过4个，可能存在医保合规风险" placement="bottom" popper-class="risk-tooltip">
            <div class="yb-tips"><i class="el-icon-warning"></i> 刷医保提醒</div>
          </el-tooltip>
        </div>
        <div class="top-right">
          <div class="top-right">
            <el-button size="medium" class="process" @click="printerPrescription(item)">打印</el-button>
          </div>
          <div class="del pointer" v-if="!isGroupOrder">
            <i class="iconfont icon-baocun" @click="saveTemplate(item)"></i>
          </div>
          <div class="del pointer" v-if="!isDisabled && !isGroupOrder">
            <i class="iconfont icon-shanch" @click="removePhysio(index, item.orderCaseProjectRecipeId)"></i>
          </div>
        </div>
      </div>
      <div class="physio-content" :class="{ 'disabled': isDisabled }">
        <div v-for="(contentItem, physioIndex) in item.items" :key="physioIndex">
          <div class="add-warp">
            <div class="index">
              <i class="el-icon-plus" v-if="physioIndex == item.items.length - 1"></i>
              <span v-else>{{ physioIndex + 1 }}</span>
            </div>
            <div class="select-warp">
              <!-- 禁用项目提示 -->
              <el-tooltip v-if="contentItem.enableStatus === 2 || contentItem.onSale == '0'" class="item" effect="dark" content="该理疗项目已被禁用"
                placement="top">
                <span class="iconfont icon-tinshou colorF54A ml8"></span>
              </el-tooltip>
              <el-select :disabled="isDisabled || isGroupOrder" v-model="contentItem.itemName" :ref="'itemName' + index + physioIndex"
                placeholder="选择理疗类型" filterable remote reserve-keyword :remote-method="getPhysioList" @change="selectPhysio($event, index, physioIndex)"
                :popper-append-to-body="false" popper-class="customSelectStyle" @focus="physioOptions = []">
                <el-option disabled value="1" style="pointer-events:none;background:#F0F1F3;">
                  <span style="width:280px; display:inline-block">项目名称</span>
                  <span style="width:64px; display:inline-block">单位</span>
                  <span style="width: 104px; display:inline-block">类型</span>
                  <span style="width: 80px; display:inline-block">价格</span>
                  <span style="width: 90px; display:inline-block">医保属性</span>
                  <span style="width: 80px; display:inline-block">spuId</span>
                </el-option>
                <el-option v-for="(obj, index1) in physioOptions" :key="index1" :label="obj.spuCommonName"
                  :value="obj.spuId">
                  <span style="width:280px; display:inline-block">{{ obj.spuCommonName }}</span>
                  <span style="width:64px; display:inline-block">{{ obj.unit || '-' }}</span>
                  <span style="width: 104px; display:inline-block">{{ obj.type || '-'
                    }}</span>
                  <span style="width: 80px; display:inline-block">{{ obj.price }}</span>
                  <span style="width: 90px; display:inline-block">{{ computedDictText(obj.medicalInsuranceType, ybPropertyList) || '-' }}</span>
                  <span style="width: 80px; display:inline-block">{{ obj.spuId }}</span>
                </el-option>
              </el-select>
            </div>
            <!-- executionMode 10 按次 20 按组 -->
            <div class="add-right" v-if="physioIndex != item.items.length - 1">
              <div class="unit-warp">单位：{{ contentItem.itemUnit }}</div>
              <div class="price-warp" v-if="contentItem.physioExtendJson && contentItem.physioExtendJson.executionMode == 20"> 
                <div>￥{{ contentItem.price &&contentItem.price.toFixed(2) }}/组</div>
                <el-tooltip placement="bottom" popper-class="risk-tooltip" v-if="contentItem.effectDrugPriceConfig && contentItem.effectDrugPriceConfig.configType == 2">
                  <div slot="content">
                    <div v-for="config in contentItem.effectDrugPriceConfig.ladderPriceConfigs">
                      <div v-if="config.ladderEndNumber">{{ config.ladderStartNumber }}-{{ config.ladderEndNumber }}{{ contentItem.physioExtendJson.executionMode == 10 ? '次': '组' }}，{{ config.ladderPrice }}元/{{ contentItem.physioExtendJson.executionMode == 10 ? '次': '组' }}</div>
                      <div v-else>{{ config.ladderStartNumber }}{{ contentItem.physioExtendJson.executionMode == 10 ? '次': '组' }}及以上，{{ config.ladderPrice }}元/{{ contentItem.physioExtendJson.executionMode == 10 ? '次': '组' }}</div>
                    </div>
                  </div>
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
              <div class="edit-warp">
                <div class="ml5 item-section">￥</div>
                <div>{{ contentItem.physioExtendJson && contentItem.physioExtendJson.executionMode == 20 ?
                  $bigNumber(contentItem.price, '*', contentItem.physioExtendJson.onlyNum) : contentItem.price }}</div>
                <div class="ml5 item-section">
                  <div>每 次</div>
                  <el-tooltip placement="bottom" popper-class="risk-tooltip" v-if="contentItem.effectDrugPriceConfig && contentItem.effectDrugPriceConfig.configType == 2">
                    <div slot="content">
                      <div v-for="config in contentItem.effectDrugPriceConfig.ladderPriceConfigs">
                        <div v-if="config.ladderEndNumber">{{ config.ladderStartNumber }}-{{ config.ladderEndNumber }}{{ contentItem.physioExtendJson.executionMode == 10 ? '次': '组' }}，{{ config.ladderPrice }}元/{{ contentItem.physioExtendJson.executionMode == 10 ? '次': '组' }}</div>
                        <div v-else>{{ config.ladderStartNumber }}{{ contentItem.physioExtendJson.executionMode == 10 ? '次': '组' }}及以上，{{ config.ladderPrice }}元/{{ contentItem.physioExtendJson.executionMode == 10 ? '次': '组' }}</div>
                      </div>
                    </div>
                    <i v-if="contentItem.physioExtendJson.executionMode == 10" class="el-icon-warning-outline"></i>
                  </el-tooltip>
                </div>
              </div>
              <div v-if="!isDisabled && !isGroupOrder" class="edit-warp" style="text-align: center; width: 40px">
                <div class="w100_" @click="delPhysioProject(index, physioIndex)"><i
                    class="el-icon-close close-item pointer" style="font-size: 16px;"></i></div>
              </div>
            </div>
          </div>
          <div class="acupoint-warp" v-if="physioIndex !== item.items.length - 1 && contentItem.physioExtendJson">
            <div class="acupoint-list">
              <div class="acupoint-item"
                v-for="(acupoint, acupointIndex) in contentItem.physioExtendJson && contentItem.physioExtendJson.acupointinfoList"
                :key="acupoint.acupointId">
                <div class="acupoint-item-tips" v-if="alreadyAdd == `note${index}${physioIndex}${acupointIndex}`">
                  已添加过该{{ acupoint.speciesType == 10 ? '穴位' : '部位' }}</div>
                <div class="acupoint-item-tips" v-if="speciesTypeTips == `note${index}${physioIndex}${acupointIndex}`">
                  选择{{ acupoint.speciesType == 10 ? '穴位' : '部位' }}不计入{{ acupoint.speciesType == 10 ? '部位' : '穴位' }}数
                </div>
                <div class="acupoint-item-tips2 w60" v-if="isDisabled && acupoint.type == 50">数量{{  acupoint.typeExtend[0]  }}</div>
                <div class="acupoint-item-tips2 w230" v-if="isDisabled && acupoint.type == 60">
                  <div v-if="computedShowAcupointTips(SiFenLeft,acupoint).flag">左手：{{computedShowAcupointTips(SiFenLeft,acupoint).str}}</div>
                  <div class="mt4" v-if="computedShowAcupointTips(SiFenRight,acupoint).flag">右手：{{computedShowAcupointTips(SiFenRight,acupoint).str}}</div>
                </div>
                <el-popover :ref="'popover' + index + physioIndex + acupointIndex" placement="bottom" trigger="click"
                  popper-class="acupoint-popover" :disabled="isDisabled || acupoint.type == 10">
                  <!-- 普通穴位 -->
                  <div class="acupoint-position" v-if="acupoint.type != 50 && acupoint.type != 60">
                    <div class="acupoint-position-item"
                      :class="{ 'acupoint-position-item-active': acupoint.type == type.value ? true : false ,
                      'acupoint-position-item-disabled': acupoint.type != 10 && type.value == 10}"
                      v-for="type in acupointType" :key="type.value"
                      @click="changeAcupointType(type.value, index, physioIndex, acupointIndex)">{{ type.label }}</div>
                  </div>
                  <!-- 阿是穴 -->
                  <div class="acupoint-position" v-if="acupoint.type == 50">
                    <div class="acupoint-position-item"
                      :class="{ 'acupoint-position-item-active': type == computedAcupointType(acupoint.type,acupoint.typeExtend) ? true : false ,
                      'acupoint-position-item-disabled': acupoint.type != 10 && type.value == 10}"
                      v-for="type in AshiPoints" :key="type"
                      @click="changeAcupointType(type, index, physioIndex, acupointIndex)">{{ type }}</div>
                  </div>
                  <!-- 四缝穴 -->
                  <div class="acupoint-SiFen" v-if="acupoint.type == 60">
                    <div>左手：</div>
                    <el-checkbox-group v-model="acupoint.typeExtend" class="mt6" :min="1" @change="SiFenChange($event,index)">
                      <el-checkbox v-for="item in SiFenLeft" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                    </el-checkbox-group>
                    <div class="mt12">右手：</div>
                    <el-checkbox-group v-model="acupoint.typeExtend" class="mt6" :min="1" @change="SiFenChange($event,index)">
                      <el-checkbox v-for="item in SiFenRight" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <el-button slot="reference" :class="isDisabled ? 'disabled acupoint-item-left' :'acupoint-item-left' ">{{
                    computedAcupointType(acupoint.type,acupoint.typeExtend)
                    }}</el-button>
                </el-popover>
                <el-select v-model="acupoint.acupointName" :disabled="isDisabled" :default-first-option="true"
                  :placeholder="contentItem.physioExtendJson && contentItem.physioExtendJson.perUnit | filterPerUnit"
                  filterable popper-class="customSelectStyle" remote reserve-keyword @focus="acupointFocus(acupoint)"
                  :remote-method="query => getAcupointsList(query)"
                  @change="changeAcupoint($event, index, physioIndex, acupointIndex)">
                  <el-option v-for="item in acupointOptions" :key="item.acupointId" :label="item.acupointName"
                    :value="item.acupointId">
                  </el-option>
                </el-select>
                <i class="el-icon-close" v-if="!isDisabled" @click="deleteAcupoint(index, physioIndex, acupointIndex)"></i>
              </div>
              <div class="acupoint-item" v-if="!isDisabled">
                <div class="acupoint-item-tips" v-if="alreadyAdd == `note${index}${physioIndex}`">已添加过该{{
                  contentItem.physioExtendJson && contentItem.physioExtendJson.perUnit | filterPerUnit }}</div>
                <el-select v-model="acupointName" :default-first-option="true" :ref="'search' + index + physioIndex"
                  :placeholder="contentItem.physioExtendJson && contentItem.physioExtendJson.perUnit | filterPerUnit"
                  filterable popper-class="customSelectStyle" remote reserve-keyword
                  :remote-method="query => getAcupointsList(query)"
                  @change="selectAcupointName($event, index, physioIndex)">
                  <el-option v-for="item in acupointOptions" :key="item.acupointId" :label="item.acupointName"
                    :value="item.acupointId">
                  </el-option>
                </el-select>
                <div class="acupoint-item-icon" @click="openAcupoint(index, physioIndex)">
                  <img :src="imgArr.acupointIcon" class="acupoint-icon" alt="">
                </div>
              </div>
            </div>
            <div class="acupoint-total" :class="{'color667':computedPerUnitCount(contentItem.physioExtendJson) < computeMultiplication(contentItem.physioExtendJson.perUnitCount,contentItem.physioExtendJson.onlyNum)}"
              v-if="contentItem.physioExtendJson && contentItem.physioExtendJson.executionMode && contentItem.physioExtendJson.perUnitCount">{{contentItem.physioExtendJson && contentItem.physioExtendJson.perUnit | filterPerUnitShow}}：
              {{ computedPerUnitCount(contentItem.physioExtendJson) }} / {{ computeMultiplication(contentItem.physioExtendJson.perUnitCount,contentItem.physioExtendJson.onlyNum) }}
            </div>
            <div class="acupoint-total" v-else>{{ contentItem.physioExtendJson && contentItem.physioExtendJson.perUnit | filterPerUnitShow}}：
              {{ computedPerUnitCount(contentItem.physioExtendJson) }}
            </div>
          </div>
          <div class="other-warp" v-if="physioIndex !== item.items.length - 1 && contentItem.physioExtendJson">
            <div class="other-warp-left">
              <div class="other-num-input">
                <el-tooltip :disabled="contentItem.physioExtendJson.soldNum < 2" class="item" effect="light" content="单个理疗项目疗程次数超过2次，可能存在医保合规风险" placement="bottom" popper-class="risk-tooltip">
                  <el-input class="num-input" :class="{'num-input-risk':contentItem.physioExtendJson.soldNum > 1}" :disabled="isDisabled || isGroupOrder" v-model="contentItem.physioExtendJson.soldNum"
                    @input="soldNumChange($event, index, physioIndex)"></el-input>
                </el-tooltip>
                <div>次</div>
              </div>
              <div class="other-num-input" @click="clickOnlyNum(index,physioIndex)"
                v-if="contentItem.physioExtendJson && contentItem.physioExtendJson.executionMode == 20">
                <div class="flex-sh">1次</div>
                <el-input class="onlyNum-input" :disabled="isDisabled" v-model="contentItem.physioExtendJson.onlyNum" :ref="'frequencyInput'+index+physioIndex"
                  @input="onlyNumChange($event, index, physioIndex)"></el-input>
                <div>组</div>
              </div>
              <div class="frequency-input">
                <SelectPanel v-model="contentItem.executeDesc" :width="'70px'" :columnsNum="3"
                  :options="physioIntervalEnumOption" :readonly="true" placeholder="频率" :disabled="isDisabled"
                  @input="physioIntervalEnumChange($event, index, physioIndex)">
                </SelectPanel>
              </div>
              <div class="other-desc"
                v-if="contentItem.physioExtendJson && contentItem.physioExtendJson.executionMode == 20 && contentItem.physioExtendJson.perUnitCount">
                每组{{ contentItem.physioExtendJson.perUnitCount }}个{{ contentItem.physioExtendJson.perUnit == 10 ? '穴位' : '部位' }}，每次至少选择{{
                  $bigNumber( contentItem.physioExtendJson.perUnitCount, '*',
                    contentItem.physioExtendJson.onlyNum)
                }}个{{ contentItem.physioExtendJson.perUnit == 10 ? '穴位' : '部位' }}</div>
              <div class="other-desc"
                v-if="contentItem.physioExtendJson && contentItem.physioExtendJson.executionMode == 10 && contentItem.physioExtendJson.perUnitCount">
                每次至少选择{{contentItem.physioExtendJson.perUnitCount}}个{{ contentItem.physioExtendJson.perUnit == 10 ? '穴位' : '部位' }}</div>
              <div class="other-tips" v-if="computedShowTips(contentItem.physioExtendJson)"><span class="iconfont icon-jingg colorFE8F mr6" style="size: 12px;"></span>选{{ contentItem.physioExtendJson.perUnit == 10 ? '部位' : '穴位'}}不计入已选数量</div>
            </div>
            <div class="other-warp-right">￥{{ contentItem.totalPrice }}</div>
          </div>
          <div class="other-warp" v-if="physioIndex !== item.items.length - 1 && contentItem.physioExtendJson">
            <div class="physio_remark_row">
              <div class="physio_remark_label">理疗备注:</div>
              <el-input
                class="physio_product_remark"
                type="textarea"
                v-model="contentItem.remark"
                placeholder="填写相关项目备注信息"
                :autosize="{ minRows: 1, maxRows: 3 }"
                resize="none"
                :disabled="isDisabled"
                clearable
                maxlength="100"
                show-word-limit
                @input="physioRemarkInput(contentItem)"
                @blur="physioRemarkBlur(contentItem);handlePhy(item)">
              </el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <acupoint-dialog
      v-if="acupointDialogShow"
      :dialogVisible="acupointDialogShow"
      @close="acupointDialogClose"
      @accupointConfirm="accupointConfirm"
      :acupointDialogObj="acupointDialogObj"
      :tabIndex = acupointDialogObj.tabIndex
      :chooseList="chooseList">
    </acupoint-dialog>
    <addTemplateDialog
      v-if="addTemplateDialogShow"
      recipeTypeAction="diagnosisAdd"
      :doctorId="doctorId"
      :form="addTemplateForm"
      recipeType="2"
      :dialogShow="addTemplateDialogShow"
      title="新增模版"
      @templateCancel="templateCancel"
      @saveSuceess="saveTemplateSuceess">
    </addTemplateDialog>
  </div>
</template>

<script>
import { physioList, getPhysioIntervalEnum } from "@/api/physio"; // 理疗请求
import { acupointList } from "@/api/acupoint"; // 穴位请求
import { deepClone, isNull, msgboxWarning, isEmptyArray, dictText,debounce } from '@/utils/validateBase';
import { Utils } from "@/utils/utils";
import { removeRecipe } from '@/api/pricingDetails';
import { Outpatient } from '../data/index.js';
import { ybCenterDrugDirectoryCategorySignList, ybPropertyList } from '@/utils/const';
import { imgArr } from "@/assets/images/img.js";
import SelectPanel from '@/components/SelectPanel.vue'
import acupointDialog from "../component/acupointDialog.vue";
import addTemplateDialog from '@/views/MedicalTemplate/addTemplateDialog'
export default {
  // 定义引入的组件
  components: { SelectPanel, acupointDialog, addTemplateDialog },
  props: {
    // 理疗处方列表
    physioItem: Array,
    type: String | Number,
    isGroupOrder: Boolean,
    consultationType: String | Number,
    isDisabled: Boolean,
    isEdit: Boolean,
    doctorId: String | Number,
  },
  data() {
    return {
      imgArr: imgArr,
      physioOptions: [],//理疗类型列表
      physioId: '',//理疗类型id
      acupointOptions: [],//穴位列表
      speciesOptions: this.$speciesOptions, // 穴位所在经脉
      ybCenterDrugDirectoryCategorySignList: ybCenterDrugDirectoryCategorySignList,
      ybPropertyList: ybPropertyList,
      acupointName: '',
      acupointType: [
        { label: '单', value: 10 },
        { label: '双', value: 20 },
        { label: '左', value: 30 },
        { label: '右', value: 40 },
      ],
      AshiPoints:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
      physioIntervalEnum: [],
      physioIntervalEnumOption: [],
      acupointDialogShow: false,
      acupointDialogObj: {},
      alreadyAdd: '',//是否添加过
      speciesTypeTips: '',
      focusAcupoint: {},//当前聚焦的穴位信息
      chooseList: [],
      SiFenLeft:[
        { label: '四缝1', value: '1-1' },
        { label: '四缝2', value: '1-2' },
        { label: '四缝3', value: '1-3' },
        { label: '四缝4', value: '1-4' },
      ],
      SiFenRight:[
        { label: '四缝1', value: '2-1' },
        { label: '四缝2', value: '2-2' },
        { label: '四缝3', value: '2-3' },
        { label: '四缝4', value: '2-4' },
      ],
      addTemplateDialogShow: false, // 处方模版显示
      addTemplateForm: {} // 新增模版对象
    }
  },
  computed: {
    computedDictText() {
      let that = this;
      return function (ybCode,list) {
        return dictText(ybCode, list)
      }
    },
    computedAcupointType() {
      let that = this;
      return function (type,typeExtend) {
        if(type == 50){
          return typeExtend[0]
        }else if( type == 60){
          return isNull(typeExtend) ? 0 : typeExtend.length
        }else{
          return dictText(type, that.acupointType)
        }
      }
    },
    computedPerUnitCount() {
      return function (physioExtendJson) {
        let num = 0
        let { acupointinfoList, perUnit } = physioExtendJson
        if (isNull(perUnit)) {
          acupointinfoList.forEach(v => {
            if(v.type == 60){
              num = num + Number((isNull(v.typeExtend) ? 0 :v.typeExtend.length))
            }else if(v.type == 50){
              num =  num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend[0]))
            }else if(v.type == 20){
              num = num + 2;
            }else{
              num = num + 1
            }
          })
        } else {
          acupointinfoList.forEach(v => {
            if (v.speciesType == perUnit) {
              if(v.type == 60){
              num = num + Number((isNull(v.typeExtend) ? 0 :v.typeExtend.length))
              }else if(v.type == 50){
                num =  num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend[0]))
              }else if(v.type == 20){
                num = num + 2;
              }else{
                num = num + 1
              }
            }
          })
        }
        return num
      }
    },
    computedShowTips(){
      return function (physioExtendJson) {
       return isNull(physioExtendJson.perUnit) ? false: physioExtendJson.acupointinfoList.some(v => v.speciesType != physioExtendJson.perUnit)
      }
    },
    computeMultiplication(){
      return function(a,b=1){
        return this.$bigNumber(a, '*', isNull(b)? 1 : b)
      }
    },
    computedShowAcupointTips(){
      let that = this;
      return function(list,acupoint){
        let str = ''
        let flag = false
        acupoint.typeExtend.forEach(v1=>{
          list.forEach(v2=>{
            if(v1 == v2.value){
              flag = true
              str = str + v2.label + '、'
            }
          })
        })
        return {str:str.slice(0, -1),flag };
      }
    }
  },
  filters: {
    filterPerUnit(val) {
      return isNull(val) ? '穴位/部位' : (val == 10 ? '穴位' : '部位')
    },
    filterPerUnitShow(val) {
      return isNull(val) ? '已选' : (val == 10 ? '穴位' : '部位')
    },
  },
  //变量监听
  watch: {
    physioItem(newV, old) {
      this.handleProps()
    },
  },
  // 页面初始化
  created() {
    this.handleProps()
    this.getPhysioIntervalEnum();//获取理疗执行周期
  
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
     * 请求穴位/部位列表
     */
    getAcupointsList(acupointName) {
      if(isNull(acupointName)){
        this.acupointOptions = []
        return;
      }
      acupointList({ acupointName, speciesType: '' }).then(res => {
        let { code, rows } = res
        if (code == 200) {
          this.acupointOptions = rows;
        }
      })
    },
    /**
  * 输入药品用量
  */
    //计算价格
    handleProps() {
      this.physioItem.forEach(val => {
        this.computePhysioPrice(val, 1)
      })
    },
    /**
     * 获取理疗类型
     */
    getPhysioList:debounce(function (query) { 
       Outpatient.getOtherProject({
        deptId: this.consultationType === 2 ? process.env.VUE_APP_CHAT_DEPT_ID : this.$session.get('deptId'),
        searchWord: query,
        types: ['3'],
        recipeType:3,
        doctorId:this.doctorId
      }).then(res => {
        if (_.isEmpty(res)) {
          this.physioOptions = []
        } else {
          this.physioOptions = res
        }
      })
    }, 200),
    /**
     * 选择理疗处方
     */
    selectPhysio(val, index, physioIndex) {
      let physioItem = deepClone(this.physioItem)
      let recipePhysioItem = physioItem[index].items
      let findArr = recipePhysioItem.filter(item => {
        return item.itemId == val
      })
      if (!_.isEmpty(findArr)) {
        this.$message.error('不可以重复添加')
        recipePhysioItem = physioItem[index].items[physioIndex].itemId = ''
        recipePhysioItem = physioItem[index].items[physioIndex].itemName = ''
        this.$emit('updataPhysioItem', physioItem)
        return;
      }
      let obj = physioItem[index].items[physioIndex]
      let length = physioItem[index].items.length
      let physioExtendJson = {}
      this.physioOptions.forEach(item => {
        if (item.spuId == val) {
          obj = { ...obj, ...item }
          obj.itemNum = item.executionMode == 20 ? this.$bigNumber(3, '*', 1) : 1
          obj.itemId = item.spuId
          physioExtendJson.perUnit = item.perUnit
          physioExtendJson.perUnitCount = item.perUnitCount
          physioExtendJson.executionMode = item.executionMode
          physioExtendJson.soldNum = 1
          physioExtendJson.onlyNum = item.executionMode == 20 ? 3 : null
          physioExtendJson.physioIntervalEnum = null
          physioExtendJson.acupointinfoList = []
          obj.executeCount = null
          obj.executeInterval = null
          obj.executeDesc = null
          if(item.effectDrugPriceConfig && item.effectDrugPriceConfig.configType == 1){
            obj.price = item.effectDrugPriceConfig.fixedPrice
          }else if(item.effectDrugPriceConfig && item.effectDrugPriceConfig.configType == 2){
            let config = this.findPriceRange(obj.itemNum,item.effectDrugPriceConfig.ladderPriceConfigs)
            obj.price = isNull(config) ? obj.price : config.ladderPrice
          }
        }
      })
      physioItem[index].items[physioIndex] = obj
      physioItem[index].items[physioIndex].physioExtendJson = physioExtendJson
      if (length == 1 || physioIndex == length - 1) {
        this.addSearch(physioItem[index].items)
      }
      this.computePhysioPrice(physioItem[index]);
      this.$nextTick(() => {
        this.$refs[`search${index}${physioIndex}`][0].focus()
      })
      this.$emit('updataPhysioItem', physioItem)
    },
    saveTemplate (item) {
      this.addTemplateForm = deepClone(item)
      const index = item.items && item.items.findIndex(obj => { return obj.onSale == '0' })
      if (index > -1) {
        return this.$message.error('存在不可售商品，不支持保存处方模版')
      }
      this.addTemplateForm.recipeTemplateDrugs = item.items.map(v => {
        v['acupointinfoList']= v.physioExtendJson && v.physioExtendJson.acupointinfoList
        v['executionMode']= v.physioExtendJson && v.physioExtendJson.executionMode
        v['onlyNum']= v.physioExtendJson && v.physioExtendJson.onlyNum
        v['perUnit']= v.physioExtendJson && v.physioExtendJson.perUnit
        v['perUnitCount']= v.physioExtendJson && v.physioExtendJson.perUnitCount
        v['physioIntervalEnum']= v.physioExtendJson && v.physioExtendJson.physioIntervalEnum
        v['soldNum']= v.physioExtendJson && v.physioExtendJson.soldNum
        return v
      })
      this.addTemplateDialogShow = true
    },
    templateCancel() {
      this.addTemplateDialogShow = false
    },
    saveTemplateSuceess(data) {
      this.templateCancel()
    },
    /**
     * 删除理疗处方
     */
    removePhysio(index, id) {
      msgboxWarning(this, {
        message: `是否确定删除该处方？`,
        confirmFn: () => {
          let physioItem = deepClone(this.physioItem)
          if (!isNull(id)) {
            Outpatient.removePrescription({ orderCaseProjectRecipeId: id }).then(res => {
              if (res.code == 200) {
                physioItem.splice(index, 1)
                this.$forceUpdate()
                this.$emit('updataPhysioItem', physioItem)
              }
            })
          } else {
            physioItem.splice(index, 1)
            this.$emit('updataPhysioItem', physioItem)
          }
        },
        cancelFn: () => {
        },
      });
    },
    /**
     * 删除理疗项目
     */
    delPhysioProject(index, physioIndex) {
      let physioItem = deepClone(this.physioItem)
      physioItem[index].items.splice(physioIndex, 1)
      this.computePhysioPrice(physioItem[index]);
      this.$emit('updataPhysioItem', physioItem)
    },
    checkAndComputed: _.debounce(function (item, contentItem) {
      contentItem.itemNum = contentItem.itemNum.replace(/^(0+)|[^\d]+/g, '')
      this.computePhysioPrice(item)
    }, 500),
    /**
     * 计算理疗处方价格
     * @param {*} physio 
     */
    computePhysioPrice(physio, num) {
      physio.totalPrice = 0;
      physio.items.forEach(item => {
        item.totalPrice = this.$bigNumber(item.price, '*', item.itemNum)
        physio.totalPrice = this.$bigNumber(item.totalPrice, '+', physio.totalPrice)
      });
      this.$forceUpdate()
      if (!num) {
        this.handlePhy(physio)
      }
    },
    /**
     * 选择理疗经脉
     */
    acupointChange(e, index) {
      let physioItem = deepClone(this.physioItem)
      let arr = []
      e.forEach(item => {
        this.acupointOptions.forEach(obj => {
          if (item == obj.acupointId) {
            arr.push({
              acupointId: item,
              acupointName: obj.acupointName
            })
          }
        })
      })
      physioItem[index].acupointList = arr
      this.$emit('updataPhysioItem', physioItem)
    },
    /**
     * 经脉选择
     */
    speciesChange() {
      this.$emit('updataPhysioItem', this.physioItem)
    },
    /**
     * 添加搜索框
     */
    addSearch(list) {
      list.push({
        itemId: '',
        itemName: '',
      })
    },
    physioRemarkInput(item) {
      // 去除换行符
      item.remark = item.remark.replace(/[\n]+/g, '')
    },
    physioRemarkBlur(item) {
      if (item.remark && item.remark.trim() == '') {
        item.remark = null
      }
    },
    //保存理疗处方信息
    handlePhy: _.debounce(function (item) {
      if (this.isDisabled || this.isEdit) return;//如果是编辑不实时保存
      let obj = _.cloneDeep(item)
      obj.items = obj.items.filter(val => val.itemId != '')
      Outpatient.editPrescription(obj).then(res => {
        if (!item.orderCaseProjectRecipeId) {
          item.orderCaseProjectRecipeId = res.data
        }
      })

    }, 500),
    searchMove(index, physioIndex) {
      this.$nextTick(() => {
        this.$refs[`itemName${index}${physioIndex + 1}`][0].focus()
      })
    },
    numberInputMove(e, type, index, physioIndex) {
      switch (type) {
        case 'up':
          if (Utils.gt(physioIndex, 0)) {
            physioIndex--;
          }
          this.$refs[`itemNum${index}${physioIndex}`][0].focus()
          this.$refs[`itemNum${index}${physioIndex}`][0].select()
          break;
        case 'down':
          if (Utils.gt(this.physioItem[index].items.length - 2, physioIndex)) {
            physioIndex++;
          }
          this.$refs[`itemNum${index}${physioIndex}`][0].focus()
          this.$refs[`itemNum${index}${physioIndex}`][0].select()
          break;
      }
    },
    //打印处方
    printerPrescription(item) {
      if (_.isEmpty(item.items)) return;
      this.$emit('handlePrint', item)
    },
    //选择穴位或部位
    selectAcupointName(val, index, physioIndex) {
      let physioItem = deepClone(this.physioItem)
      let item = physioItem[index].items[physioIndex]
      let acupointinfoList = item.physioExtendJson.acupointinfoList || []
      let acupointIndex = acupointinfoList.findIndex(v => {
        return v.acupointId == val
      })
      if (acupointIndex > -1) {
        this.alreadyAdd = `note${index}${physioIndex}`
        this.acupointName = ''
        setTimeout(() => {
          this.alreadyAdd = '';//是否添加过
        }, 2000)
        return;
      }
      let acupoint = this.acupointOptions.find(v => { return v.acupointId == val })
      if(acupoint.type == 50){
        acupoint.typeExtend = ['1']
      }else if(acupoint.type == 60){
        acupoint.typeExtend = ['1-1','1-2','1-3','1-4','2-1','2-2','2-3','2-4']
      }
      item.physioExtendJson.acupointinfoList.push(acupoint)
      if (item.physioExtendJson.perUnit && item.physioExtendJson.perUnit != acupoint.speciesType) {
        this.speciesTypeTips = `note${index}${physioIndex}${item.physioExtendJson.acupointinfoList.length - 1}`
        setTimeout(() => {
          this.speciesTypeTips = '';
        }, 2000)
      }
      this.$nextTick(()=>{
        this.$refs[`search${index}${physioIndex}`][0].blur()
        this.$refs[`search${index}${physioIndex}`][0].focus()
      })
      this.$emit('updataPhysioItem', physioItem)
      this.handlePhy(physioItem[index])
      this.acupointName = ''
      this.acupointOptions = []
      this.$forceUpdate()
     
    },
    //改变穴位或部位
    changeAcupoint(val, index, physioIndex, acupointIndex) {
      let physioItem = deepClone(this.physioItem)
      let item = physioItem[index].items[physioIndex]
      let aIndex = item.physioExtendJson.acupointinfoList.findIndex(v => {
        return v.acupointId == val
      })
      if (aIndex > -1) {
        this.alreadyAdd = `note${index}${physioIndex}${acupointIndex}`
        item.physioExtendJson.acupointinfoList[acupointIndex].acupointName = ''
        this.acupointOptions = []
        setTimeout(() => {
          this.alreadyAdd = '';//是否添加过
          item.physioExtendJson.acupointinfoList[acupointIndex] = this.focusAcupoint
          this.$emit('updataPhysioItem', physioItem)
        }, 2000)
        this.$emit('updataPhysioItem', physioItem)
        return;
      }
      let acupointObj = this.acupointOptions.find(v => { return v.acupointId == val })
      if(acupointObj.type == 50){
        acupointObj.typeExtend = ['1']
      }else if(acupointObj.type == 60){
        acupointObj.typeExtend = ['1-1','1-2','1-3','1-4','2-1','2-2','2-3','2-4']
      }
      item.physioExtendJson.acupointinfoList[acupointIndex] = acupointObj
      if (item.physioExtendJson.perUnit && item.physioExtendJson.perUnit != acupointObj.speciesType) {
        this.speciesTypeTips = `note${index}${physioIndex}${acupointIndex}`
        setTimeout(() => {
          this.speciesTypeTips = '';
        }, 2000)
      }
      this.$nextTick(()=>{
        this.$refs[`search${index}${physioIndex}`][0].blur()
        this.$refs[`search${index}${physioIndex}`][0].focus()
      })
      this.$emit('updataPhysioItem', physioItem)
      this.handlePhy(physioItem[index])
      this.acupointName = ''
      this.acupointOptions = []
    },
    //获取理疗执行周期
    async getPhysioIntervalEnum() {
      getPhysioIntervalEnum().then(res => {
        if (res.code == 200) {
          this.physioIntervalEnum = res.data || []
          let list = []
          res.data.forEach(v => {
            list.push({
              label: v.executeDesc,
              value: v.executeDesc
            })
          })
          this.physioIntervalEnumOption = list
        }
      })
    },
    physioIntervalEnumChange(val, index, physioIndex) {
      let physioIntervalEnum = this.physioIntervalEnum.find(v => { return v.executeDesc === val })
      let physioItem = deepClone(this.physioItem)
      let item = physioItem[index].items[physioIndex]
      if (isNull(val)) {
        item.executeCount = null
        item.executeInterval = null
        item.executeDesc = null
        item.physioExtendJson.physioIntervalEnum = null
      } else {
        item.executeCount = physioIntervalEnum.executeCount
        item.executeInterval = physioIntervalEnum.executeInterval
        item.executeDesc = physioIntervalEnum.executeDesc
        item.physioExtendJson.physioIntervalEnum = physioIntervalEnum.key
      }
      this.$emit('updataPhysioItem', physioItem)
      this.handlePhy(physioItem[index])
    },
    changeAcupointType(val, index, physioIndex, acupointIndex) {
      let physioItem = deepClone(this.physioItem)
      let item = physioItem[index].items[physioIndex]
      let acupoint = item.physioExtendJson.acupointinfoList[acupointIndex]
      if( acupoint.type != 10 && acupoint.type != 60 && acupoint.type != 50 && val == 10){ return}
      if(acupoint.type == 50){
        acupoint.typeExtend = [`${val}`]
      }else{
        acupoint.type = val
      }
      this.$emit('updataPhysioItem', physioItem)
      this.handlePhy(physioItem[index])
      this.$refs[`popover${index}${physioIndex}${acupointIndex}`][0].doClose()
    },
    soldNumChange(val, index, physioIndex) {
      let physioItem = deepClone(this.physioItem)
      let item = physioItem[index].items[physioIndex]
      item.physioExtendJson.soldNum = item.physioExtendJson.soldNum && item.physioExtendJson.soldNum.replace(/^(0+)|[^\d]+/g, '');
      item.itemNum = item.physioExtendJson.executionMode == 20 ? this.$bigNumber(item.physioExtendJson.onlyNum, '*', item.physioExtendJson.soldNum) : item.physioExtendJson.soldNum || 0
      let config = this.findPriceRange(item.itemNum,item.effectDrugPriceConfig.ladderPriceConfigs)
      if(item.effectDrugPriceConfig.configType == 2 && !isNull(config)){
        item.price = config.ladderPrice
      }
      this.$emit('updataPhysioItem', physioItem)
      this.handlePhy(physioItem[index])
    },
    onlyNumChange(val, index, physioIndex) {
      let physioItem = deepClone(this.physioItem)
      let item = physioItem[index].items[physioIndex]
      item.physioExtendJson.onlyNum = item.physioExtendJson.onlyNum && item.physioExtendJson.onlyNum.replace(/^(0+)|[^\d]+/g, '');
      item.itemNum = this.$bigNumber(item.physioExtendJson.soldNum, '*', item.physioExtendJson.onlyNum)
      let config = this.findPriceRange(item.itemNum,item.effectDrugPriceConfig.ladderPriceConfigs)
      if(item.effectDrugPriceConfig.configType == 2 && !isNull(config)){
        item.price = config.ladderPrice
      }
      this.$emit('updataPhysioItem', physioItem)
      this.handlePhy(physioItem[index])
    },
    deleteAcupoint(index, physioIndex, acupointIndex) {
      let physioItem = deepClone(this.physioItem)
      let item = physioItem[index].items[physioIndex]
      item.physioExtendJson.acupointinfoList.splice(acupointIndex, 1)
      this.$emit('updataPhysioItem', physioItem)
      this.handlePhy(physioItem[index])
    },
    acupointDialogClose() {
      this.acupointDialogShow = false
    },
    openAcupoint(index, physioIndex) {
      let list = this.physioItem[index].items[physioIndex].physioExtendJson.acupointinfoList
      this.chooseList =  deepClone(list) 
      this.acupointDialogObj.index = index
      this.acupointDialogObj.physioIndex = physioIndex
      this.acupointDialogObj.tabIndex = ( !isNull(this.physioItem[index].items[physioIndex].physioExtendJson.perUnit) && this.physioItem[index].items[physioIndex].physioExtendJson.perUnit) == 20 ? 2 : 0
      this.acupointDialogShow = true
    },
    accupointConfirm(obj) {
      let { index, physioIndex, chooseList } = obj
      chooseList.forEach(v=>{
        if(v.type == 50){
          v.typeExtend = isNull(v.typeExtend) ? ['1'] : v.typeExtend
        }else if(v.type == 60){
          v.typeExtend = isNull(v.typeExtend) ? ['1-1','1-2','1-3','1-4','2-1','2-2','2-3','2-4'] : v.typeExtend
        }
      })
      let physioItem = deepClone(this.physioItem)
      let item = physioItem[index].items[physioIndex]
      item.physioExtendJson.acupointinfoList = chooseList
      this.$emit('updataPhysioItem', physioItem)
      this.handlePhy(physioItem[index])
      this.acupointDialogShow = false
    },
    acupointFocus(obj) {
      this.acupointOptions = []
      this.focusAcupoint = deepClone(obj)
    },
    clickOnlyNum(index,physioIndex){
      this.$nextTick(()=>{
        this.$refs[`frequencyInput${index}${physioIndex}`][0].select()
      })
    },
    SiFenChange(val,index){
      let physioItem = deepClone(this.physioItem)
      this.$emit('updataPhysioItem', physioItem)
      this.handlePhy(physioItem[index])
    },
    findPriceRange(val, configs) {
      for (let i = 0; i < configs.length; i++) {
        const config = configs[i];
        const ladderStartNumber = config.ladderStartNumber;
        const ladderEndNumber = config.ladderEndNumber;
        // 处理max为空字符串的情况（表示无上限）
        if (isNull(ladderEndNumber)) {
          if (val >= ladderStartNumber) {
            return config;
          }
        } 
        // 正常区间判断
        else {
          if (val >= ladderStartNumber && val <= ladderEndNumber) {
            return config;
          }
        }
      }
      // 没有找到匹配的区间
      return null;
    }
  },
}
</script>
<style lang="less" scoped src="./index.less"></style>
<style lang="less">
.risk-tooltip{
  background: #FFFDE9 !important;
  color: #000 !important;
  font-size: 14px !important;
  border: none !important;
  .popper__arrow{
    border: none !important;
    &::after{
      border-bottom-color: #FFFDE9 !important;
    }
  }
}
.acupoint-popover {
  padding: 0;
  min-width: 120px;
  margin-top: 4px !important;

  .popper__arrow {
    display: none;
  }

  .acupoint-position {
    display: flex;
    flex-wrap: wrap;
    border: 1px solid #E0E0E0;
    border-radius: 0px 2px 2px 0px;
    max-width: 200px;
    .acupoint-position-item {
      width: 40px;
      height: 38px;
      background: #FFFFFF;
      border-right: 1px solid #E0E0E0;
      border-bottom: 1px solid #E0E0E0;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      flex-shrink: 0;
      box-sizing: border-box;
      // &:last-child {
      //   border-right: none;
      // }
    }

    .acupoint-position-item-active {
      background: #409EFF;
      color: #fff;
    }
    .acupoint-position-item-disabled {
      background: #F7F8F9;
      cursor: not-allowed;
      color: #000 !important;
    }
  }
  .acupoint-SiFen{
    padding: 12px;
    width: 304px;
    box-sizing: border-box;
    .el-checkbox{
      margin-right: 16px;
      .el-checkbox__label{
        padding-left: 3px;
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
}
</style>